export default __webpack_public_path__ + "static/media/WrongAnswer.4710349d.mp3";